// The spool's coverage labels, copied here so this package imports only types from apps/desktop.
// The desktop spool (apps/desktop/src/shared/capture.ts `coverageLabel`) stays the owner of the
// wording; tests/call-client/desktop-capture.test.ts fails if the two ever differ.
import type { CaptureCoverage } from '../../../../apps/desktop/src/shared/capture.js';

/** Exact user-facing description; the renderer must not invent a stronger one. */
export function coverageLabel(coverage: CaptureCoverage): string {
  switch (coverage) {
    case 'local_and_remote_as_heard':
      return 'This computer: your microphone and the call audio you heard. Not the official recording.';
    case 'microphone_only':
      return 'This computer: your microphone only. The other party is not in this copy.';
    case 'remote_only':
      return 'This computer: the call audio you heard only. Your microphone is not in this copy.';
    case 'partial':
      return 'This computer: incomplete. One or more sources were missing for part of the call.';
  }
}
